import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { RequisitionLineRead } from '../../entities/requisition-line.dto';

@Injectable()
export class RequisitionLineStore extends AbstractEntityStore<RequisitionLineRead> {
    constructor() {
        super(PFWmsEntities.RequisitionLine);
    }
}
